import React from 'react';
import { ClickAwayListener, MenuList, Paper, Popper, Fade } from '@mui/material';

export function PopperMenuList({ anchorEl, onClose, children }) {
    const open = Boolean(anchorEl);

    return (
        <Popper
            open={open}
            anchorEl={anchorEl}
            placement='bottom-end'
            disablePortal
            transition
            style={{ zIndex: 1300 }}
        >
            {({ TransitionProps }) => (
                <Fade {...TransitionProps} timeout={150}>
                    <div>
                        <ClickAwayListener onClickAway={onClose}>
                            <Paper
                                sx={{
                                    fontSize: '14px',
                                    mt: { xs: '10px', desktop: '13px' },
                                    borderRadius: 0,
                                    minWidth: 150,
                                    bgcolor: 'background.paper'
                                }}
                            >
                                <MenuList autoFocusItem={false} sx={{ py: 0 }}>
                                    {children}
                                </MenuList>
                            </Paper>
                        </ClickAwayListener>
                    </div>
                </Fade>
            )}
        </Popper>
    );
}
